var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-owner"},[_vm._m(0),_c('div',{staticClass:"tips nick"},[_vm._v("\n        "+_vm._s(_vm.ownerInfo.nick)+"\n    ")]),_c('div',{staticClass:"tips other"},[_vm._v("\n        主播不在线，再逛逛吧\n    ")])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"avatar-wraper"},[_c('img',{staticClass:"avatar",attrs:{"src":require("../../../../assets/image/live/shimian.png")}})])
}]

export { render, staticRenderFns }